module.exports = __webpack_public_path__ + "img/welcome-step-1.c361fa60.png";